import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUserClasses(id, token) {
  const url = 'api/user/' + id + '/classes/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getClass(id, token) {
  const url = 'api/class/' + id + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getClasses(
  online,
  lat,
  lng,
  classType,
  instructor,
  userTimezone,
  day,
  startTime,
  endTime,
  language,
  ordering,
  page,
  pageSize,
) {
  const url = 'api/class/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      online,
      lat,
      lng,
      class_type: classType,
      instructor,
      timezone: userTimezone,
      day,
      start_time: startTime,
      end_time: endTime,
      language,
      order_by: ordering,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getOnlineClasses(
  instructor,
  classType,
  day,
  startTime,
  endTime,
  userTimezone,
  page,
  pageSize,
) {
  const url = 'api/class/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      online: true,
      instructor,
      class_type: classType,
      day,
      start_time: startTime,
      end_time: endTime,
      timezone: userTimezone,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateClass(classId, niaclass, token) {
  console.log(niaclass);
  const url = 'api/class/' + classId + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      location: niaclass.location,
      class_type: niaclass.class_type,
      language: niaclass.language,
      cost: niaclass.cost,
      description: niaclass.description,
      monday: niaclass.monday,
      monday_start: niaclass.monday_start,
      monday_end: niaclass.monday_end,
      tuesday: niaclass.tuesday,
      tuesday_start: niaclass.tuesday_start,
      tuesday_end: niaclass.tuesday_end,
      wednesday: niaclass.wednesday,
      wednesday_start: niaclass.wednesday_start,
      wednesday_end: niaclass.wednesday_end,
      thursday: niaclass.thursday,
      thursday_start: niaclass.thursday_start,
      thursday_end: niaclass.thursday_end,
      friday: niaclass.friday,
      friday_start: niaclass.friday_start,
      friday_end: niaclass.friday_end,
      saturday: niaclass.saturday,
      saturday_start: niaclass.saturday_start,
      saturday_end: niaclass.saturday_end,
      sunday: niaclass.sunday,
      sunday_start: niaclass.sunday_start,
      sunday_end: niaclass.sunday_end,
      img: niaclass.img,
      active: niaclass.active,
      attendance_type: niaclass.attendance_type,
      link: niaclass.link,
      timezone: niaclass.timezone,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createClass(userId, niaclass, token) {
  // console.log('niaclass: ', niaclass);
  const url = 'api/class/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      user: userId,
      location: niaclass.location,
      class_type: niaclass.class_type,
      language: niaclass.language,
      cost: niaclass.cost,
      description: niaclass.description,
      monday: niaclass.monday,
      monday_start: niaclass.monday_start,
      monday_end: niaclass.monday_end,
      tuesday: niaclass.tuesday,
      tuesday_start: niaclass.tuesday_start,
      tuesday_end: niaclass.tuesday_end,
      wednesday: niaclass.wednesday,
      wednesday_start: niaclass.wednesday_start,
      wednesday_end: niaclass.wednesday_end,
      thursday: niaclass.thursday,
      thursday_start: niaclass.thursday_start,
      thursday_end: niaclass.thursday_end,
      friday: niaclass.friday,
      friday_start: niaclass.friday_start,
      friday_end: niaclass.friday_end,
      saturday: niaclass.saturday,
      saturday_start: niaclass.saturday_start,
      saturday_end: niaclass.saturday_end,
      sunday: niaclass.sunday,
      sunday_start: niaclass.sunday_start,
      sunday_end: niaclass.sunday_end,
      img: niaclass.img,
      active: niaclass.active,
      attendance_type: niaclass.attendance_type,
      link: niaclass.link,
      timezone: niaclass.timezone,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function deleteClass(classId, token) {
  const url = 'api/class/' + classId + '/';
  return axios({
    method: 'delete',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}


export {
  getUserClasses,
  getClass,
  getClasses,
  getOnlineClasses,
  updateClass,
  createClass,
  deleteClass,
};
